import { render, staticRenderFns } from "./TicketDetailCardAssignees.vue?vue&type=template&id=4a126ecd"
import script from "./TicketDetailCardAssignees.vue?vue&type=script&lang=ts"
export * from "./TicketDetailCardAssignees.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports